module.exports = __webpack_public_path__ + "assets/653e065e9dbbcce2500fa9cf8dc214ab.wav";